import { createFileRoute, redirect } from '@tanstack/react-router';
import { getCurrentAppState } from 'merchant-api/derived';

export const Route = createFileRoute('/application/')({
  loaderDeps: ({ search }) => ({
    statuses: search.statuses,
  }),
  loader: async ({ deps }) => {
    const result = await getCurrentAppState({ statuses: deps.statuses });
    if (!result) throw redirect({ to: '/apply/landing' });
    throw redirect({
      to: `/application/$id/${result.state}`,
      params: { id: result.id },
    });
  },
});
